export enum GridDisplayEnum {
  SMALL = 'small',
  BIG = 'big',
}
